import { useCallback, useMemo } from "react";

import { getLineOffsets } from "~/components/get-line-offsets";

export function useCodeLines(text: string) {
  const lineOffsets = useMemo(() => getLineOffsets(text), [text]);

  const getLine = useCallback(
    (index: number) => {
      if (index < 0 || index >= lineOffsets.length) {
        return "";
      }
      const start = lineOffsets[index];
      const end = index + 1 < lineOffsets.length ? lineOffsets[index + 1] : text.length;
      let line = text.slice(start, end);

      // Remove trailing newline characters
      if (line.endsWith("\n")) {
        line = line.slice(0, -1);
      }
      if (line.endsWith("\r")) {
        line = line.slice(0, -1);
      }
      return line;
    },
    [text, lineOffsets],
  );

  const count = lineOffsets.length;
  const digits = String(count).length;

  return { getLine, count, digits };
}
